<!--
  Lovi
  2020-1-7
-->
<template>
  <div id="app" v-wechat-title="$t('common.pageTitle')">
    <transition :name="transitionName">
      <keep-alive :include="include">
        <router-view></router-view>
      </keep-alive>
      <!-- <keep-alive v-if="$route.meta.keepAlive">
        <router-view></router-view>
      </keep-alive>
      <router-view v-if="!$route.meta.keepAlive"></router-view> -->
    </transition>

    <loading v-show="loading"></loading>
    <float-service v-if="$route.meta.service"></float-service>
    <tab-bar v-if="$route.meta.tabNav"></tab-bar>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import Loading from "@/components/common/loading.vue";
import TabBar from "@/components/common/tabbar.vue";
import FloatService from "@/components/common/floatService.vue";
export default {
  components: {
    Loading,
    TabBar,
    FloatService
  },
  data() {
    return {
      transitionName: ""
    };
  },
  created() {
    // if (!localStorage.getItem("location")) {
    //   this.$store.dispatch("SET_LOCATION"); // 获取位置
    // }
    // this.$store.dispatch("GET_PLATFORM_INFO");

    // let language = localStorage.getItem("language");
    // let lang = navigator.language || navigator.userLanguage;
    // console.log(language, lang);
    // if (!language && (lang == "en" || lang == "en-us" || lang == "en-US")) {
    //   localStorage.setItem("language", "en");
    //   this.$router.go(0);
    // }

    if (localStorage.getItem("token")) {
      this.$store.dispatch("GET_USER_INFO"); // 刷新获取个人信息
    }
  },
  computed: {
    ...mapGetters(["loading", "showNav", "backFlag", "include"])
  },
  methods: {},
  watch: {
    $route(to, from) {
      console.log(to, from);
      if (this.backFlag) {
        this.transitionName = "slide-left";
        // console.log("1111111", to);
        // if (this.include.indexOf(to.name) == -1) {
        //   // 如果返回的页面被清掉后，让他再次进入缓存
        //   this.$store.dispatch("PUSH_INCLUDE", to.name);
        // }
      } else {
        // console.log("222222222", to);
        // if (to.meta.keepAlive) {
        //   this.$store.dispatch("PUSH_INCLUDE", to.name);
        // }
        this.transitionName = "slide-right";
      }
    }
  }
};
</script>

<style lang="less">
.slide-right-enter-active,
.slide-right-leave-active,
.slide-left-enter-active,
.slide-left-leave-active {
  will-change: transform;
  transition: all 0.3s;
  height: 100%;
  top: 0px;
  position: absolute;
  backface-visibility: hidden;
  perspective: 1000;
}
.slide-left-enter {
  transform: translate3d(-100%, 0, 0);
}
.slide-left-leave-active {
  transform: translate3d(100%, 0, 0);
}
.slide-right-enter {
  transform: translate3d(100%, 0, 0);
}
.slide-right-leave-active {
  transform: translate3d(-100%, 0, 0);
}
</style>
